<template>
  <j-modal
    :title="title"
    width="45%"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }"
    @ok="handleOk"
    @cancel="handleCancel"
    :okText="$t('确定')"
    :cancelText="$t('关闭')"
    :okButtonProps="{ class: { 'jee-hidden': !disableSubmit } }"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-divider orientation="left">{{ $t('基本信息') }}</a-divider>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-descriptions :column="2">
                <a-descriptions-item :label="$t('编码')"> {{ model.node.code }} </a-descriptions-item>
                <a-descriptions-item :label="$t('名称')"> {{ model.node.name }} </a-descriptions-item>
                <a-descriptions-item :label="$t('类型')">
                  {{ filterDictTextByCache('node_type', model.node.type) }}
                </a-descriptions-item>
                <a-descriptions-item :label="$t('高程')">{{ model.node.height }}</a-descriptions-item>
              </a-descriptions>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <div id="chart" style="width: 100%; height: 300px" v-show="echartsShow"></div>
              <div style="width: 100%;" v-show="!echartsShow">
                <a-empty :image="Empty.PRESENTED_IMAGE_SIMPLE">
                  <span slot="description"> {{ $t('暂无数据!') }} </span>
                </a-empty>
              </div>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>
    
    <script>
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import JSearchSelectTag from '../../../../components/dict/JSearchSelectTag.vue'
import { filterDictTextByMany, filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import echarts from 'echarts'
import moment from 'moment'
import {Empty} from 'ant-design-vue'
export default {
  name: 'modal',
  components: {
    JSearchSelectTag,
  },
  data() {
    return {
      Empty: Empty,
      filterDictTextByCache: filterDictTextByCache,
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      model: {},
      validatorRules: {},
      url: {
        getIotDataCurve: '/jeecg-gis/nodeIotConfig/getIotDataCurve',
      },
      iotModel: {},
      echartsShow: false,
    }
  },
  computed: {
    title() {
      return this.$t('曲线图')
    },
  },
  methods: {
    init(row) {
      
      this.visible = true
      this.model = {};
      this.model = Object.assign({}, row)
      console.log("看看数据123",this.model);
      this.$nextTick(() => {
        this.getData()
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    handleOk() {},
    getData() {
      if (this.model.iotData) {
        console.log("看看数据",this.model);
        
        this.echartsShow = true;
        let params = {
          deviceId: this.model.iotData.deviceid || this.model.iotData.meterId,
          nodeType: this.model.node.type,
          begin: moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
          end: moment().format('YYYY-MM-DD HH:mm:ss'),
        }
        console.log("提交数据",params);
        postAction(this.url.getIotDataCurve, params).then(res => {
          if (res.success) {
            this.setChartData(res.result)
          } else {
            this.$message.error(res.message)
          }
        })
      }else{
        this.echartsShow = false;
      }
    },
    setChartData(data) {
      let xdata = []
      let ydata = []
      let min = data.min
      let max = data.max
      data.curveDataList.map(item => {
        xdata.push(item.time)
        ydata.push(item.value)
      })
      var chart = document.getElementById('chart')
      var myChart = echarts.init(chart)
      var option = {
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: '8%',
          right: '8%',
          bottom: '20%',
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: 'none',
            },
            dataView: { readOnly: false },
            magicType: { type: ['line', 'bar'] },
            restore: {},
            saveAsImage: {},
          },
          iconStyle: {
            color: '#fff'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xdata,
          axisLabel: {
            color: '#fff'
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          splitLine: {
            // X轴网格线
            show: true,
            lineStyle: {
              color: '#fff',
              type: 'dashed',
            },
          },
        },
        yAxis: {
          type: 'value',
          min: min,
          max: max,
          axisLabel: {
            color: '#fff'
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          splitLine: {
            // Y轴网格线
            show: true,
            lineStyle: {
              color: '#fff',
              type: 'dashed',
            },
          },
        },
        dataZoom: [
          {
            type: 'inside',
          },
          {
            type: 'slider',
          },
        ],
        series: [
          {
            type: 'line',
            data: ydata,
          },
        ],
      }
      myChart.setOption(option)
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    },
  },
}
</script>
<style lang="less" scoped>
::v-deep .ant-modal-content,
::v-deep .ant-modal-header{
  background-color: rgba(70, 76, 92, 0.8);
  color: #fff;
}
::v-deep .ant-modal-title,
::v-deep .anticon,
::v-deep .ant-divider-horizontal,
::v-deep .ant-descriptions-item-label,
::v-deep .ant-descriptions-item-content,
::v-deep .ant-empty-normal{
  color: #fff;
}
::-webkit-scrollbar {
    background-color: red; /* 设置滚动条背景色 */
    // width: 12px; /* 设置滚动条宽度 */
}
::-webkit-scrollbar-thumb {
    background-color: red; /* 设置滚动条滑块颜色 */
    // border-radius: 6px; /* 设置滑块圆角 */
}
::v-deep .scrollbar {
  scrollbar-color: red red;
  scrollbar-width: thin;
}
</style>